// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.admin-row {
  align-items: center;
  display: flex;
  margin-top: 40px;
}
.admin-row .admin-link {
  margin-right: 50px;
}

.admin-row:last-of-type {
  margin-bottom: 40px;
}

.tool-tip-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
}
.tool-tip-container span {
  font-weight: 500;
  padding: 5px 0;
}

.status-box {
  border-radius: 5px;
  background-color: white;
  border: 2px solid #CB321A;
  color: black;
  font-size: 0.87rem;
  font-weight: 500;
  padding: 2px 8px;
  text-align: center;
  width: fit-content;
}

.in-progress {
  border: 2px solid #FEBF31;
}

.released {
  border: 2px solid green;
}

.ready {
  border: none;
  background: #FEBF31;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Home.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;AAUJ;AARI;EACI,kBAAA;AAUR;;AANA;EACG,mBAAA;AASH;;AANA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AASJ;AARI;EACI,gBAAA;EACA,cAAA;AAUR;;AANA;ECzBI,kBD0BsB;EACtB,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AASJ;;AANA;EACI,yBAAA;AASJ;;AANA;EACI,uBAAA;AASJ;;AANA;EACI,YAAA;EACA,mBD3BQ;ACoCZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.admin-row {\n    align-items: center;\n    display: flex;\n    margin-top: 40px;\n\n    .admin-link {\n        margin-right: 50px;\n    }\n}\n\n.admin-row:last-of-type {\n   margin-bottom: 40px;\n}\n\n.tool-tip-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n    span {\n        font-weight: 500;\n        padding: 5px 0;\n    }\n}\n\n.status-box {\n    @include borderRadius(5px);\n    background-color: white;\n    border: 2px solid $red;\n    color: black;\n    font-size: 0.87rem;\n    font-weight: 500;\n    padding: 2px 8px;\n    text-align: center;\n    width: fit-content;\n}\n\n.in-progress {\n    border: 2px solid $important;\n}\n\n.released {\n    border: 2px solid green;\n}\n\n.ready {\n    border: none;\n    background: $important;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
